import styled from 'styled-components';

import { Grid, Button, Pagination } from '@mui/material';

export const TableContainer = styled.div`
    background: #ffffff;
    border-radius: 15px;
    padding: 24px;
    box-shadow: 0px 3px 12px rgba(81, 69, 159, 0.08);
`;

export const TableHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

export const TableTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #25272e;
    margin: 0;
`;

export const ExcelButton = styled(Button)`
    width: 154px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-self: flex-end;
    justify-content: space-between;
    padding: 0px 16px;
    text-transform: capitalize;
    background: #3a6647;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    color: #ffffff;
    font-family: 'Myriad Pro', sans-serif;
    font-weight: 600;
    font-size: 16px;

    &:hover {
        background: #2d5038;
    }
`;

export const TableStyled = styled(Grid)`
    border: 1px solid #cdd2d9;
    border-radius: 8px;
    overflow: hidden;
`;

export const HeaderRow = styled(Grid)`
    font-weight: 600;
    font-size: 14px;
    background-color: #f0f1f3;
    color: #25272e;
`;

export const HeaderCell = styled(Grid)`
    text-align: ${({ align }) => align || 'center'};
    padding: 12px 8px;
    white-space: nowrap;
`;

export const BodyRow = styled(Grid)`
    &:nth-child(even) {
        background-color: #fafafa;
    }

    &:hover {
        background-color: #f5f5f5;
    }
`;

export const BodyCell = styled(Grid)`
    padding: 10px 8px;
    border-top: 1px solid #e8e8e8;
    text-align: ${({ align }) => align || 'center'};
    font-size: 14px;
    color: #464646;
    display: flex;
    align-items: center;
    justify-content: ${({ align }) => (align === 'left' ? 'flex-start' : 'center')};
`;

export const StatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    min-width: 106px;
    height: 24px;
    line-height: 1;

    svg {
        display: flex;
        align-items: center;
    }

    ${({ status }) => {
        switch (status) {
            case 'approved':
                return `
                    background-color: #62C054;
                    color: #ffffff;
                `;
            case 'pending':
                return `
                    background-color: #DF7F0F;
                    color: #ffffff;
                `;
            case 'not_visited':
                return `
                    background-color: #D35E4B;
                    color: #ffffff;
                `;
            default:
                return `
                    background-color: #f5f5f5;
                    color: #757575;
                `;
        }
    }}
`;

export const CheckIcon = styled.span`
    color: #4caf50;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CloseIcon = styled.span`
    color: #f44336;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const DashIcon = styled.span`
    color: #9e9e9e;
    font-size: 18px;
`;

export const ViewButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9e9e9e;
    transition: color 0.2s;

    &:hover {
        color: #3a6647;
    }
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
`;

export const PerPageSelect = styled.div`
    display: flex;
    align-items: center;
    .MuiTextField-root {
        min-width: auto !important;

        .MuiOutlinedInput-root {
            border: none;
            padding: 0;

            .MuiOutlinedInput-notchedOutline {
                border: none;
            }

            .MuiSelect-select {
                padding: 0;
                font-size: 16px;
                color: #464646;
                min-width: auto !important;
            }
        }
    }

    .MuiSelect-icon {
        color: #3a6647;
        font-size: 22px;
        pointer-events: none;
        position: relative;
        right: 0;
    }
`;

export const StyledPagination = styled(Pagination)`
    & .MuiPaginationItem-root {
        border-color: #3a6647;

        &.Mui-selected {
            background-color: white;
            border-color: #3a6647;
            color: #3a6647;
        }
    }
`;

export const EmptyState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px;
    color: #9e9e9e;
    font-size: 14px;
`;
